import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

/**
 * QuestionnaireV1 widget configs
 */
const questionnaireV1Semantics = {
    'mainWrapClass': 'questionnaire-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'actionElement': '.questionnaire-v1__btn',
};

/**
 * QuestionnaireV1 initializer
 */
$(function () {
    QuestionnaireV1.init();
});

class QuestionnaireV1 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${questionnaireV1Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.questionnaireV1) {
            window.widgets.questionnaireV1 = new QuestionnaireV1();
        }

        /**
         * Checking other instances
         */
        $(`.${questionnaireV1Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${questionnaireV1Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.questionnaireV1.registerInstance($(el));
                window.widgets.questionnaireV1.registerPopup($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${questionnaireV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${questionnaireV1Semantics.mainWrapClass}`);
            el.attr(`${questionnaireV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerPopup(el) {
        let actionBtn = el.find(questionnaireV1Semantics.actionElement);
         actionBtn.magnificPopup({
            items: {
                src: actionBtn.attr('data-popup'),
                type: 'inline'
            },
            midClick: true,
            showCloseBtn: false
        });
    }

    reInit(instanceId) {
        QuestionnaireV1.init();
    }
}